var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVaultLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "40px",
    viewBox: "0 0 45 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ED08918D-AC7C-4D7B-B39A-74B5F043626A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zenvoya-JULY-2024",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HOTEL-DETAILS-2",
    transform: "translate(-117.000000, -1352.000000)",
    fill: "#7CBEEA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(10.250000, 111.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(106.750000, 1236.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vault-light",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,2.5 C3.6171875,2.5 2.5,3.6171875 2.5,5 L2.5,32.5 C2.5,33.8828125 3.6171875,35 5,35 L40,35 C41.3828125,35 42.5,33.8828125 42.5,32.5 L42.5,5 C42.5,3.6171875 41.3828125,2.5 40,2.5 L5,2.5 Z M0,5 C0,2.2421875 2.2421875,0 5,0 L40,0 C42.7578125,0 45,2.2421875 45,5 L45,32.5 C45,35.2578125 42.7578125,37.5 40,37.5 L40,38.75 C40,39.4375 39.4375,40 38.75,40 C38.0625,40 37.5,39.4375 37.5,38.75 L37.5,37.5 L7.5,37.5 L7.5,38.75 C7.5,39.4375 6.9375,40 6.25,40 C5.5625,40 5,39.4375 5,38.75 L5,37.5 C2.2421875,37.5 0,35.2578125 0,32.5 L0,5 Z M27.5,18.75 C27.5,13.2271525 23.0228475,8.75 17.5,8.75 C11.9771525,8.75 7.5,13.2271525 7.5,18.75 C7.5,24.2728475 11.9771525,28.75 17.5,28.75 C23.0228475,28.75 27.5,24.2728475 27.5,18.75 Z M5,18.75 C5,11.8464406 10.5964406,6.25 17.5,6.25 C24.4035594,6.25 30,11.8464406 30,18.75 C30,25.6535594 24.4035594,31.25 17.5,31.25 C10.5964406,31.25 5,25.6535594 5,18.75 Z M17.5,21.25 C18.8807119,21.25 20,20.1307119 20,18.75 C20,17.3692881 18.8807119,16.25 17.5,16.25 C16.1192881,16.25 15,17.3692881 15,18.75 C15,20.1307119 16.1192881,21.25 17.5,21.25 Z M17.5,13.75 C20.2614237,13.75 22.5,15.9885763 22.5,18.75 C22.5,21.5114237 20.2614237,23.75 17.5,23.75 C14.7385763,23.75 12.5,21.5114237 12.5,18.75 C12.5,15.9885763 14.7385763,13.75 17.5,13.75 Z M37.5,13.75 C37.5,13.0596441 36.9403559,12.5 36.25,12.5 C35.5596441,12.5 35,13.0596441 35,13.75 C35,14.4403559 35.5596441,15 36.25,15 C36.9403559,15 37.5,14.4403559 37.5,13.75 Z M40,13.75 C40,15.3828125 38.953125,16.7734375 37.5,17.2890625 L37.5,26.25 C37.5,26.9375 36.9375,27.5 36.25,27.5 C35.5625,27.5 35,26.9375 35,26.25 L35,17.2890625 C33.546875,16.7734375 32.5,15.3828125 32.5,13.75 C32.5,11.6796875 34.1796875,10 36.25,10 C38.3203125,10 40,11.6796875 40,13.75 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaultLight);
export default __webpack_public_path__ + "static/media/vault-light.1be7a5002fc23917c31b2d2900956ea9.svg";
export { ForwardRef as ReactComponent };